import posthog from 'posthog-js';

import { AccessScope, ContextUser } from '@/modules/common/types';
import { ContextCompany } from '@/modules/common/types/company';

/**
 * Identify the current user and bind them to their company.
 * Call once per page-load (e.g. inside your guarded loader).
 */
export function posthogIdentify(user?: ContextUser | null, company?: ContextCompany | null) {
  if (!posthog || !user) return;

  posthog.identify(user.id, {
    email: user.email,
    role: user.role,
    preferred_language: user.language,
    environment: import.meta.env.VITE_ENV, // dev / staging / prod …
  });

  if (company) {
    posthog.group('company', company.id, {
      name: company.name,
      accountType: company.accountType,
      status: company.status,
      numberOfEmployees: company.employeesNum,
      product: company.accessScope === AccessScope.MATERIALITY ? 'DMA_ONLY' : 'FULL_ACCESS',
    });
  }
}

/**
 * Lightweight helper for `$pageview` events.
 *
 * @param url   request.url as received inside the loader
 * @param area  optional logical area of the app (“survey”, “app”, …)
 */
export function posthogPageview(url: string, area = 'app') {
  if (!posthog) return;

  const { pathname } = new URL(url, window.location.origin);

  posthog.capture('$pageview', {
    actual_path: pathname,
    area,
  });
}
